<template>
  <div class="materials-item-check-list">
    <img
      src="/img/materials/items/check-list-preview.webp"
      data-lazy-src="/img/materials/items/check-list.webp"
      alt="image"
      loading="lazy"
    >

    <h3>чек-лист по&nbsp;переходу в&nbsp;онлайн‑школу</h3>
    <p>узнайте о&nbsp;плюсах и&nbsp;минусах семейной и&nbsp;заочной формы обучения</p>
    <button
      class="m-btn"
      @click="openModal(MODAL_TYPES.checkList)"
    >
      скачать чек-лист
    </button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { MODAL_TYPES } from '../v2/common/AppHeader/data';

export default {
  name: 'MaterialsItemCheckList',
  data: () => ({
    MODAL_TYPES,
  }),
  methods: {
    ...mapActions('appHeaderModals', {
      openModal: 'openModal',
    }),
  },
};
</script>

<style scoped lang="scss">

.materials-item-check-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: calc(var(--scale) * 16) calc(var(--scale) * 20) calc(var(--scale) * 20);
  border-radius: calc(var(--scale) * 40);
  position: relative;

  @include media-down($size-tablet) {
    padding: calc(var(--scale) * 13) calc(var(--scale) * 8);
    border-radius: calc(var(--scale) * 32);
  }

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    object-fit: cover;
  }

  h3 {
    margin-bottom: calc(var(--scale) * 12);
    position: relative;

    font-weight: 500;
    font-size: calc(var(--scale) * 48);
    line-height: 110%;
    letter-spacing: -0.02em;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      margin-bottom: calc(var(--scale) * 10);
      padding-left: calc(var(--scale) * 8);
      font-size: calc(var(--scale) * 44);
      line-height: 90%;
      letter-spacing: -0.06em;
    }
  }

  p {
    position: relative;

    font-weight: 500;
    font-size: calc(var(--scale) * 26);
    line-height: 120%;
    color: rgba(255, 255, 255, 0.5);

    @include media-down($size-tablet) {
      padding-left: calc(var(--scale) * 8);
      font-size: calc(var(--scale) * 20);
      line-height: 110%;
      letter-spacing: -0.02em;
    }
  }

  button {
    margin-top: auto;
    width: 100%;
    padding-block: calc(var(--scale) * 31) calc(var(--scale) * 34);
    background-color: #FF5319;
    backdrop-filter: blur(5px);
    border-radius: calc(var(--scale) * 24);
    transition: 200ms;

    font-weight: 500;
    font-size: calc(var(--scale) * 26);
    line-height: 120%;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      padding-block: calc(var(--scale) * 27);
      font-size: calc(var(--scale) * 22);
    }

    @media (hover: hover) {
      &:hover {
        background-color: #FF9C12;
      }
    }
  }
}

</style>
